export const UPDATE_ATIVIDADES = 'UPDATE_ATIVIDADES'
export const ADD_ATIVIDADES = 'ADD_ATIVIDADES'
export const SET_ATIVIDADES = 'SET_ATIVIDADES'
export const REMOVE_ATIVIDADES = 'REMOVE_ATIVIDADES'
export const SET_ATIVIDADE = 'SET_ATIVIDADE'
export const SET_ATIVIDADE_NULL = 'SET_ATIVIDADE_NULL'